import React, {Component} from 'react';
import HeaderSectionComponent from '../HeaderSectionComponent/HeaderSectionComponent';
import TermsAndConditionsComponent from '../TermsAndConditionsComponent/TermsAndConditionsComponent';
import CalloutCardComponent from '../CalloutCardComponent/CalloutCardComponent';

class TermsAndConditionsPageComponent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let options = {'sitename': this.props.siteName};
        let cardContent = (
            <TermsAndConditionsComponent
                lingua={this.props.lingua}
                siteName = {this.props.siteName}
                isWaiting = {this.props.isWaiting}
                updatePage={this.props.updatePage}
                onClose={this.props.onClose}
                emailAddress={this.props.emailAddress}
                site={this.props.site}
            />
        );
        return (
            <div className="TermsAndConditionsPageComponent border-border-color">
                <HeaderSectionComponent header={this.props.lingua.read('lex.header.terms.conditions', options)}/>
                <CalloutCardComponent content={cardContent} error={''} errorTitle={''} />
            </div>
        );
    }
}

export default TermsAndConditionsPageComponent;
